import { Center, ProviderType } from '@/types/models'
import { getProviderType } from '@/domain/center'
export const isResidentialProvider = (center: Center) =>
  (getProviderType(center) as ProviderType) === ProviderType.RESIDENTIAL

export const isHospitalProvider = (center: Center) =>
  getProviderType(center) === ProviderType.HOSPITAL
